import { render, staticRenderFns } from "./JobBoard.vue?vue&type=template&id=cad62ee2&"
import script from "./JobBoard.vue?vue&type=script&lang=js&"
export * from "./JobBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports